import { useUser } from "auth";
import { useCallback, useEffect } from "react";
import { IDLE_EVENTS, IDLE_LAST_ACTIVE_KEY, IDLE_TIMEOUT } from "./constants";

const isIdle = () => {
  const value = window.localStorage.getItem(IDLE_LAST_ACTIVE_KEY);
  const lastActivity = parseInt(value, 10);

  if (isNaN(lastActivity)) {
    return false;
  }

  return Date.now() - lastActivity >= IDLE_TIMEOUT;
};

let throttleTimeoutId = null;
const throttleDuration = 500;

export const updateLastActive = () => {
  if (throttleTimeoutId) {
    return;
  }

  window.localStorage.setItem(IDLE_LAST_ACTIVE_KEY, Date.now().toString());

  throttleTimeoutId = setTimeout(
    () => (throttleTimeoutId = null),
    throttleDuration,
  );
};

export const removeLastActive = () => {
  window.localStorage.removeItem(IDLE_LAST_ACTIVE_KEY);
};

export const IdleManager = () => {
  const { claims, clearSession } = useUser();

  const onIdle = useCallback(() => {
    clearSession();
  }, [clearSession]);

  useEffect(() => {
    if (!claims.admin) {
      return;
    }

    const controller = new AbortController();

    IDLE_EVENTS.forEach((event) => {
      document.addEventListener(
        event,
        () => {
          updateLastActive();
        },
        {
          capture: true,
          passive: true,
          signal: controller.signal,
        },
      );
    });

    return () => {
      controller.abort();
    };
  }, [claims.admin]);

  useEffect(() => {
    if (!claims.admin) {
      return;
    }

    if (isIdle()) {
      return onIdle();
    }

    const interval = setInterval(() => {
      if (isIdle()) {
        onIdle();
      }
    }, 1_000);

    return () => {
      clearInterval(interval);
    };
  }, [claims.admin, onIdle]);

  return null;
};
